/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import {
  Paper,
} from '@material-ui/core';
import Lightbox from 'react-image-lightbox';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import SiteAssignRow from './SiteAssignRow';
import {
  approveRejectSiteReport,
  createNewTask,
  notifyMonitor,
  updateSiteLinkForReport,
} from '../../redux/actions/sites';
import FallbackCard from '../../CommonComponents/FallbackCard';
import 'react-image-lightbox/style.css';

const headCells = [
  {
    id: 'startDate',
    numeric: false,
    disablePadding: true,
    label: 'Duration',
  },
  {
    id: 'mediaType',
    numeric: true,
    disablePadding: false,
    label: 'Media',
  },
  {
    id: 'monitor',
    numeric: true,
    disablePadding: false,
    label: 'Monitor',
  },
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'locationName',
    numeric: true,
    disablePadding: false,
    label: 'Location',
  },

  {
    id: 'progress',
    numeric: false,
    disablePadding: false,
    label: 'Progress',
  },
  {
    id: 'tasks',
    numeric: false,
    disablePadding: false,
    label: 'Tasks',
  },
  {
    id: 'View',
    numeric: false,
    disablePadding: false,
    label: 'View',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  right: {
    float: 'right',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    float: 'right',
    marginLeft: 20,
    width: 200,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
  accordion: {
    boxShadow: 'none',
    display: 'block',
    padding: 0,
  },
  detailBtn: {
    marginLeft: 'auto',
    fontWeight: 'bold',
    marginTop: '4px',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#bdbdbd',
    justifyContent: 'center',
    alignContent: 'center',
    alignSelf: 'center',
  },
  cancel: {
    position: 'absolute',
    top: 5,
    right: 10,
    zIndex: 1,
    color: '#fff',
  },
  pointer: {
    cursor: 'pointer',
  },
  noImage: {
    backgroundColor: '#333333',
    textAlign: 'center',
  },
}));

const SiteAssignTable = ({
  allSites,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId')
  const [imageIndex, setImageIndex] = useState(0);
  const [openApprovedView, setOpenApprovedView] = useState(false);
  const [approvedLightBox, setApprovedLightBox] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleApprovedViewDetails = (approvedImage) => {
    setApprovedLightBox(approvedImage.site_reports)
    setOpenApprovedView(true)
  }

  return (
    <div className={classes.root}>
      {allSites.length > 0 ? (
        <div>
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={allSites.length}
                  checkbox
                />
                <TableBody>
                  {stableSort(allSites, getComparator(order, orderBy))
                    .map((row) => (
                      <SiteAssignRow
                        key={row.id}
                        row={row}
                        handleApprovedViewDetails={handleApprovedViewDetails}
                      />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}

      {openApprovedView && (
        <Lightbox
          imageTitle={`Task Date: ${approvedLightBox[imageIndex].visitDate}`}
          mainSrc={approvedLightBox[imageIndex].approvedUrl}
          nextSrc={approvedLightBox[(imageIndex + 1) % approvedLightBox.length].approvedUrl}
          prevSrc={approvedLightBox[(imageIndex + approvedLightBox.length - 1) % approvedLightBox.length].approvedUrl}
          onMovePrevRequest={() => setImageIndex((imageIndex + approvedLightBox.length - 1) % approvedLightBox.length)}
          onMoveNextRequest={() => setImageIndex((imageIndex + 1) % approvedLightBox.length)}
          onCloseRequest={() => setOpenApprovedView(false)}
        />
      )}

    </div>
  );
};

const mapState = (state) => ({
  allSites: state.common.sitesOfClientDashboard,
  // currentPageCount: state.sites.currentPageCount,
});

const mapActions = {
  approveRejectSite: approveRejectSiteReport,
  notify: notifyMonitor,
  updateSiteReportLink: updateSiteLinkForReport,
  createNTask: createNewTask,
};

export default connect(mapState, mapActions)(SiteAssignTable);
